module.exports = __webpack_public_path__ + "img/kefuc.98f6706e.png";